import {CdPsaItem} from '../../../interfaces/care/cd-care-plan/cd-psa-item';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from './cd-frequency-factory';

export class CdPsaItemFactory {
  /**
   *
   * @param cdPsaItem
   */
  public static fromJson(cdPsaItem: any): CdPsaItem {
    return new class implements CdPsaItem {
      id: number = cdPsaItem.id;
      name: string = cdPsaItem.name;
      cdFrequencies: CdFrequency[] =
        cdPsaItem.c_frequencies ? CdFrequencyFactory.fromArray(cdPsaItem.c_frequencies) : [];
    };
  }
  /**
   *
   * @param psaItems
   */
  public static fromArray(psaItems: any[]): CdPsaItem[] {
    return psaItems.map(CdPsaItemFactory.fromJson);
  }}
